<template>
  <div>
    <section
      class="pdf-item bg-white w-full p-4 border rounded-lg bg-gray-50 mb-4"
    >
      <div class="w-full">
        <h6 class="p-4">{{ reportData.form.reportType }}</h6>
      </div>
      <BarChart :chart-data="chartData" :options="chartOptions" :height="150" />
    </section>
    <!-- summary section -->
    <section class="pdf-item bg-white p-4 border rounded-lg w-full bg-gray-50">
      <SimpleTable
        class="mt-2"
        title="Power Billing Report"
        :headers="header()"
        :items="commonSummaryData()"
        :options="options"
      />
    </section>
    <!-- summary section -->
  </div>
</template>
<script>
import BarChart from '@/components/Chart/Bar'
import HistoricalReport from '@/components/Reports/HistoricalReport'
import SimpleTable from '@/components/dx/SimpleTable'
import AnyChart from '@/components/Reports/AnyChart'
import PdfReportTemplate from '@/components/Reports/PdfReport'
import reportContentMixin from '@/mixins/ReportContent'

export default {
  mixins: [reportContentMixin],
  props: {
    period: {
      type: String
    },
    exportPdf: {
      type: Boolean
    }
  },
  components: {
    BarChart,
    HistoricalReport,
    SimpleTable,
    AnyChart
  },
  data() {
    return {
      grouppedAssets: [],
      assets: [],
      assetsProperties: [],
      grouppedData: {},
      chartOptions: {
        layout: {
          padding: {
            top: 10
          }
        },
        plugins: {
          datalabels: {
            // hide datalabels for all datasets
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        title: {
          display: false
        },
        tooltips: true,
        hover: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                zeroLineColor: 'transparent'
              },
              ticks: {
                padding: 20,
                fontColor: '#000',
                fontStyle: 'bold'
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true
              },
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'kW'
              }
            }
          ]
        }
      },
      chartData: {},
      options: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: true,
        autoWidth: false
      }
    }
  },
  mounted() {
    this.chartData = {
      labels: this.reportData.report.ListCustomer.map(
        (data) => data.CompanyName
      ),
      datasets: [
        {
          label: 'Contracted',
          backgroundColor: '#ea0008',
          data: this.reportData.report.ListCustomer.map(
            (data) => data.DetailPowerITA.TotalContractedPower
          )
        },
        {
          label: 'Peak',
          backgroundColor: '#f8737d',
          data: this.reportData.report.ListCustomer.map(
            (data) => data.DetailSensorDCEPower.PeakStr
          )
        },
        {
          label: 'Average',
          backgroundColor: '#c0272d',
          data: this.reportData.report.ListCustomer.map(
            (data) => data.DetailSensorDCEPower.AverageStr
          )
        }
      ]
    }
  },
  methods: {
    header() {
      return [
        {
          type: 'string',
          text: 'Customer Name',
          value: 'Customer Name'
        },
        {
          type: 'string',
          text: 'Customer ID',
          value: 'Customer ID'
        },
        {
          type: 'string',
          text: 'Contracted kW',
          value: 'Contracted kW'
        },
        {
          type: 'string',
          text: 'Peak Utilization',
          value: 'Peak Utilization'
        },
        {
          type: 'string',
          text: 'Status',
          value: 'Status'
        }
      ]
    },
    commonSummaryData() {
      var bodyData = []

      // get sensor data

      this.reportData.report.ListCustomer.map((data, index) => {
        let content = {}
        content['Id'] = index
        content['Customer Name'] = data.CompanyName
        content['Customer ID'] = data.CustomerItaId
        content['Contracted kW'] = data.DetailPowerITA.TotalContractedPower
        content['Peak Utilization'] = data.DetailSensorDCEPower.PeakStr
        content['Status'] = data.Status

        bodyData.push(content)
      })

      return bodyData
    },

    preparePdf() {
      try {
        this.$emit('pdfSource', {
          filename: this.getGeneratedFileName(),
          source: []
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
